import type { WhiteLabel } from '@skytech/types'

export const getAppName = (whiteLabel: WhiteLabel | null) => {
  let appName = 'Manager'

  if (whiteLabel === 'telia') {
    appName = 'Telia Manager'
  }

  if (whiteLabel === 'ice') {
    appName = 'Ice Manager'
  }

  if (whiteLabel === 'tietoevry') {
    appName = 'TietoEVRY Manager'
  }

  if (whiteLabel === 'csi') {
    appName = 'CSI Manager'
  }

  if (whiteLabel === 'mobit') {
    appName = 'Mobit Manager'
  }

  if (whiteLabel === 'ikomm') {
    appName = 'Manager'
  }

  return appName
}
